import store from '@state/store'

// auth related routes
const authRoutes = [
  {
    path: '/login',
    name: 'login',
    component: () => lazyLoadView(import('@views/pages/account/login')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/loggedIn']) {
          next({ name: 'Dashboard' })
        } else {
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')
        next({ name: 'login' })
      },
    },
  },
]

// dashboard
const dashboardRoutes = [
  {
    path: '/',
    name: 'Dashboard',
    icon: 'home',
    component: () => lazyLoadView(import('@views/pages/dashboard/dashboard')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
]

// apps
const integracaoRoutes = [
  {
    path: '/register',
    name: 'Integrações',
    icon: 'cloud',
    meta: { authRequired: true },
    component: {
      render(c) {
        return c('router-view')
      },
    },
    children: [
      {
        path: 'integracao',
        name: 'São Paulo - CREA',
        header: 'Integração',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/integracao/sp')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'siga',
        name: 'Rio Grande do Sul - SIGA',
        header: 'Integração',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/siga/downloadCSV')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'estoque-ba',
        name: 'Bahia - ADAB',
        header: 'Integração',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/integracao/ba')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'receituario-pr',
        name: 'Paraná - SIAGRO',
        header: 'Integração',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/integracao/pr')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'receituario-mg',
        name: 'Minas Gerais - IMA',
        header: 'Integração',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/integracao/mg')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'receituario-sc',
        name: 'Santa Catarina - SIGEN',
        header: 'Integração',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/integracao/sc')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'receituario-mt',
        name: 'Mato Grosso - INDEA',
        header: 'Integração',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/integracao/mt')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'receituario-go',
        name: 'Goiás - SIGEA',
        header: 'Integração',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/integracao/go')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
    ],
  },
]

const cadastrosRoutes = [
  {
    path: '/cadastros',
    name: 'Cadastros',
    icon: 'save',
    meta: { authRequired: true },
    component: {
      render(c) {
        return c('router-view')
      },
    },
    children: [
      {
        path: 'cliente',
        name: 'Cliente',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/cadastros/cliente')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'produto',
        name: 'Produto',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/cadastros/produto')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'tipo-produto',
        name: 'Tipo do Produto',
        icon: 'cloud',
        component: () =>
          lazyLoadView(import('@views/pages/cadastros/tipo-produto')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'unidade',
        name: 'Unidade',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/cadastros/unidade')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
    ],
  },
]

const documentacaoRoutes = [
  {
    path: '/docs',
    name: 'Treinamentos',
    icon: 'book',
    meta: { authRequired: true },
    component: {
      render(c) {
        return c('router-view')
      },
    },
    children: [
      {
        path: 'videos',
        name: 'Vídeos',
        header: 'API',
        icon: 'share-2',
        component: () => lazyLoadView(import('@views/pages/docs/videos')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'suporte',
        name: 'Suporte',
        header: 'Suporte',
        icon: 'share-2',
        component: () => lazyLoadView(import('@views/pages/docs/suporte')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      // {
      //   path: 'documentacao',
      //   name: 'API',
      //   header: 'API',
      //   icon: 'share-2',
      //   component: () => lazyLoadView(import('@views/pages/docs/documentacao')),
      //   meta: { authRequired: true },
      //   props: (route) => ({ user: store.state.auth.currentUser || {} }),
      // },
    ],
  },
]

const receituarioRoutes = [
  {
    path: '/register',
    name: 'Receituário',
    icon: 'clipboard',
    meta: { authRequired: true },
    component: {
      render(c) {
        return c('router-view')
      },
    },
    children: [
      {
        path: 'produtores',
        name: 'Produtor',
        icon: 'user',
        header: '',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/produtor_rural')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'responsavel-tecnico',
        name: 'Responsável Técnico',
        icon: 'users',
        meta: { authRequired: true },
        component: () => lazyLoadView(import('@views/pages/register/agronomo')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'receita',
        name: 'Receita',
        header: 'Menu',
        icon: 'clipboard',
        component: () => lazyLoadView(import('@views/pages/register/receita')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'gerar-receita-xml',
        name: 'Receituário por XML',
        header: 'Menu',
        icon: 'clipboard',
        component: () =>
          lazyLoadView(import('@views/pages/register/gerar-receita-xml')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'ficha-emergencia',
        name: 'Ficha de Emergência',
        icon: 'users',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/ficha-emergencia')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'consulta-fitossanitaria',
        name: 'Consulta Fitossanitária',
        icon: 'users',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/fitossanitaria')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      // {
      //   path: 'cliente',
      //   name: 'Cliente',
      //   icon: 'cloud',
      //   component: () => lazyLoadView(import('@views/pages/cadastros/cliente')),
      //   meta: { authRequired: true },
      //   props: (route) => ({ user: store.state.auth.currentUser || {} }),
      // },
      {
        path: 'produto',
        name: 'Produto',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/cadastros/produto')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'produto-vinculo',
        name: 'Vinculação de Produtos',
        icon: 'cloud',
        component: () =>
          lazyLoadView(import('@views/pages/cadastros/produto-vinculo')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'tipo-produto',
        name: 'Tipo do Produto',
        icon: 'cloud',
        component: () =>
          lazyLoadView(import('@views/pages/cadastros/tipo-produto')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'unidade',
        name: 'Unidade',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/cadastros/unidade')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
    ],
  },
]

const receituarioSyngentaRoutes = [
  {
    path: '/register',
    name: 'Syngenta',
    icon: 'clipboard',
    meta: { authRequired: true },
    component: {
      render(c) {
        return c('router-view')
      },
    },
    children: [
      // {
      //   path: 'produtores',
      //   name: 'Produtor',
      //   icon: 'user',
      //   header: '',
      //   meta: { authRequired: true },
      //   component: () =>
      //     lazyLoadView(import('@views/pages/register/produtor_rural')),
      //   props: (route) => ({ user: store.state.auth.currentUser || {} }),
      // },
      {
        path: 'responsavel-tecnico',
        name: 'Responsável Técnico',
        icon: 'users',
        meta: { authRequired: true },
        component: () => lazyLoadView(import('@views/pages/register/agronomo')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'receita',
        name: 'Receita',
        header: 'Menu',
        icon: 'clipboard',
        component: () => lazyLoadView(import('@views/pages/register/receita')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'gerar-receita-xml',
        name: 'Receituário por XML',
        header: 'Menu',
        icon: 'clipboard',
        component: () =>
          lazyLoadView(import('@views/pages/register/gerar-receita-xml')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'ficha-emergencia',
        name: 'Ficha de Emergência',
        icon: 'users',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/ficha-emergencia')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'produto-vinculo',
        name: 'Vinculação de Produtos',
        icon: 'cloud',
        component: () =>
          lazyLoadView(import('@views/pages/cadastros/produto-vinculo')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
    ],
  },
]

const fichaEmergenciaRoutes = [
  {
    path: '/query',
    name: 'Ficha Emergência',
    icon: 'clipboard',
    meta: { authRequired: true },
    component: {
      render(c) {
        return c('router-view')
      },
    },
    children: [
      {
        path: 'ficha-emergencia',
        name: 'Ficha de Emergência',
        icon: 'users',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/ficha-emergencia')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
    ],
  },
]

const gerencialRoutes = [
  {
    path: '/register',
    name: 'Gerencial',
    icon: 'save',
    meta: { authRequired: true },
    // create a container component
    component: {
      render(c) {
        return c('router-view')
      },
    },
    children: [
      {
        path: 'produtos',
        name: 'Produto',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () => lazyLoadView(import('@views/pages/register/produto')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'empresas',
        name: 'Empresas',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () => lazyLoadView(import('@views/pages/register/empresas')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'vincular-plano',
        name: 'Vincular Plano',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/vincular-plano')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'itens-produtos',
        name: 'Relações',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/item-produto')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'restricoes-estado',
        name: 'Restrições Estado',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/restricoes-estado')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'pragas',
        name: 'Praga',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () => lazyLoadView(import('@views/pages/register/praga')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'empresas',
        name: 'Empresa',
        icon: 'home',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () => lazyLoadView(import('@views/pages/register/empresa')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'classes-toxicologicas',
        name: 'Classe Toxicológica',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/classe-toxicologica')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'culturas',
        name: 'Cultura',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () => lazyLoadView(import('@views/pages/register/cultura')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'unidades',
        name: 'Unidade',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () => lazyLoadView(import('@views/pages/register/unidade')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'classe-produto',
        name: 'Classe do Produto',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/tipo-produto')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'tipo-formulacao',
        name: 'Tipo Formulação',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/tipo-formulacao')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'tipo-aplicacao',
        name: 'Tipo Aplicação',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/tipo-aplicacao')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'locais-aplicacao',
        name: 'Local Aplicação',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/local-aplicacao')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'grupos-alvos',
        name: 'Grupo Alvo',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/grupo-alvo')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'epocas-alvos',
        name: 'Época Alvo',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/epoca-alvo')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'estados',
        header: 'Cadastros',
        name: 'Estados',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () => lazyLoadView(import('@views/pages/register/estado')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'conta-bancaria',
        header: 'Cadastros',
        name: 'Conta Bancária',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/conta-bancaria')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'categoria-conta',
        header: 'Cadastros',
        name: 'Categorias/Fluxo de Caixa',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/categoria-conta')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'centro-custo',
        header: 'Cadastros',
        name: 'Centro de Custo',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/centro-custo')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'ingrediente-ativo',
        header: 'Cadastros',
        name: 'Ingrediente Ativo',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/ingrediente-ativo')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'grupo-quimico',
        header: 'Cadastros',
        name: 'Grupo químico',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/grupo-quimico')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'meio-ambiente',
        header: 'Cadastros',
        name: 'Meio ambiente',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/register/meio-ambiente')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
    ],
  },
]

const financeiroRoutes = [
  {
    path: '/financeiro',
    name: 'Financeiro',
    icon: 'dollar-sign',
    meta: { authRequired: true },
    // create a container component
    component: {
      render(c) {
        return c('router-view')
      },
    },
    children: [
      {
        path: 'categoria-conta',
        name: 'Categoria de Conta',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/finances/categoria-conta')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'tipo-conta',
        name: 'Contas',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/finances/tipo-conta')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'centro-custo',
        name: 'Centro de Custo',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/finances/centro-custo')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      // {
      //   path: 'conciliacao-bancaria',
      //   name: 'Conciliação Bancária',
      //   icon: 'box',
      //   // header: 'Cadastros',
      //   meta: { authRequired: true },
      //   component: () =>
      //   lazyLoadView(import('@views/pages/finances/conciliacao-bancaria')),
      //   props: (route) => ({ user: store.state.auth.currentUser || {} }),
      // },
      {
        path: 'contas-a-pagar',
        name: 'Contas Pagar',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/finances/contas-a-pagar')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'contas-a-receber',
        name: 'Contas Receber',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/finances/contas-a-receber')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'fluxo-de-caixa',
        name: 'Fluxo de Caixa',
        icon: 'box',
        // header: 'Cadastros',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/finances/fluxo-de-caixa')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      // {
      //   path: 'recibo',
      //   name: 'Recibo',
      //   icon: 'box',
      //   // header: 'Cadastros',
      //   meta: { authRequired: true },
      //   component: () =>
      //   lazyLoadView(import('@views/pages/finances/recibo')),
      //   props: (route) => ({ user: store.state.auth.currentUser || {} }),
      // },
    ],
  },
]

// apps
const fiscalRoutes = [
  {
    path: '/estoque',
    name: 'Estoque',
    icon: 'file-text',
    meta: { authRequired: true },
    component: {
      render(c) {
        return c('router-view')
      },
    },
    children: [
      {
        path: 'entrada-nf',
        name: 'Entrada de Nota Fiscal',
        header: 'Integração',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/fiscal/entrada-nf')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'movimentacao',
        name: 'Estoque',
        icon: 'box',
        meta: { authRequired: true },
        component: () =>
          lazyLoadView(import('@views/pages/estoque/movimentacao')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
    ],
  },
]

const tributarioRoutes = [
  {
    path: '/tributario',
    name: 'Tributário',
    icon: 'percent',
    meta: { authRequired: true },
    component: {
      render(c) {
        return c('router-view')
      },
    },
    children: [
      {
        path: 'upload',
        name: 'Upload de arquivos',
        icon: 'box',
        component: () => lazyLoadView(import('@views/pages/upload/upload')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'processamento',
        name: 'Processamento de arquivos',
        icon: 'box',
        component: () =>
          lazyLoadView(import('@views/pages/upload/processamentos')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
    ],
  },
]

const configRoutes = [
  {
    path: '/configuracao',
    name: 'Configurações',
    icon: 'settings',
    meta: { authRequired: true },
    component: {
      render(c) {
        return c('router-view')
      },
    },
    children: [
      {
        path: 'empresa',
        name: 'Empresa',
        icon: 'box',
        component: () => lazyLoadView(import('@views/pages/config/empresa')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'config',
        name: 'Configuração',
        icon: 'box',
        component: () =>
          lazyLoadView(import('@views/pages/config/configuracao')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'webhook',
        name: 'WebHook',
        icon: 'box',
        component: () => lazyLoadView(import('@views/pages/config/webhook')),
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
    ],
  },
]

const authProtectedRoutes = [
  ...dashboardRoutes,
  ...receituarioRoutes,
  ...receituarioSyngentaRoutes,
  ...fichaEmergenciaRoutes,
  ...fiscalRoutes,
  ...financeiroRoutes,
  ...integracaoRoutes,
  ...gerencialRoutes,
  ...configRoutes,
  ...documentacaoRoutes,
]

const allRoutes = [...authRoutes, ...authProtectedRoutes]

export { allRoutes, authProtectedRoutes }

function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    delay: 400,
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      return h(AsyncHandler, data, children)
    },
  })
}
